import { Loader2 } from "lucide-react";

export function MobileDeepLinkLoader() {
    return (
        <div className="flex items-center justify-center min-h-[400px]">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
    );
}
